/*
    方法一：路由比对权限
    方法二：指定返回的默认路由
 */

import { set } from "nprogress";

/**
 * 
 * @param {Array*} userRouter  // 后台返回的路由权限
 * @param {Array*} allRouter  // 前端配置好的权限
 * @returns  {Array} realRouter // 过滤之后符合条件的路由
 */

export function recursionRouter(userRouter = [], allRouter = []) {
    var realRouter = [];
    allRouter.forEach((v, i) => {

        userRouter.forEach((item, index) => {
            if (item.name == v.meta.name) {
                if (item.children && item.children.length > 0) {
                    v.children = recursionRouter(item.children, v.children)
                }


                realRouter.push(v)
            }
        })
    })



    return realRouter
}


export function setDefaultRoute(routes) {
    routes.forEach((v, i) => {
        if (v.children && v.children.length > 0) {
            v.redirect = {
                name: v.children[0].name
            }
            setDefaultRoute(v.children)
        }
    })
}